<template>
  <v-container>
    <v-card>
      <v-card-title>
        <span class="title mb-1" style="color:#1271A6">Disponibilidad Semanal</span>
        <v-spacer></v-spacer>
        <v-btn v-if="fuShow(['propio'])" @click="fuSave()" color="primary" :loading="dLoading"><v-icon>save</v-icon> Guardar</v-btn>
      </v-card-title>
      <v-card-text>
        <v-simple-table v-if="disponibilidad.length != []">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left pa-1">Bloque</th>
                <th class="text-left">Hora</th>
                <th v-for="dia in dias" :key="dia" class="text-center pa-2">{{ dia }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(bloque, rowIndex) in bloques" :key="bloque.id">
                <td class="bloque-column">{{ bloque.id }}</td>
                <td>{{ bloque.hora }}</td>
                <td v-for="(dia, colIndex) in dias" :key="dia"
                  :class="{'green-cell': disponibilidad[rowIndex][colIndex] === true, 'red-cell': disponibilidad[rowIndex][colIndex] === false, 'clickable-cell': true}"
                  @click="toggleDisponibilidad(rowIndex, colIndex)"
                >
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
export default {
    name: 'DisponibilidadHoraria',
    props: {
        pIdPersonal: {
            default: null,
            type: Number
        },
        pRol: {
            default: '',
            type: String
        },
    },
    mounted() {
        this.fuLoad(this.pIdPersonal);
    },
    watch: {
        pIdPersonal(val){
            if(val){
                this.fuLoad(parseInt(val));
            }
        },
    },
    data() {
        return {
            dLoading: false,
            dias: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
            diasMap: {
                'Lunes': 0, 'Martes': 1, 'Miércoles': 2, 'Jueves': 3, 'Viernes': 4, 'Sábado': 5, 'Domingo': 6
            },
            bloques: [
                { id: 1, hora: '07:00 - 08:30' },
                { id: 2, hora: '08:30 - 10:00' },
                { id: 3, hora: '10:00 - 11:30' },
                { id: 4, hora: '11:30 - 13:00' },
                { id: 5, hora: '14:00 - 15:30' },
                { id: 6, hora: '15:30 - 17:00' },
                { id: 7, hora: '17:00 - 18:30' },
                { id: 8, hora: '18:30 - 20:00' },
                { id: 9, hora: '20:00 - 21:30' },
                { id: 10, hora: '21:30 - 22:10' },
            ],
            disponibilidad: [], // Aquí se almacenará la matriz
            ddcbdisponibilidadHoraria: [],
        };
    },
    computed: {
        ...mapState(['ssUser']),
    },
    methods: {
        fuShow(pArray){
            if(!this.pRol) return false;
            return pArray.includes(this.pRol);            
        },
        async fuLoad() {            
            this.dLoading = true;
            this.dPricurriculums = [];
            try {
                const response = await this.$apollo.query({
                    query: gql`
                        query consulta($IDDOCENTE: Int!, $DISPONIBILIDAD: Int!, $ESTADODISPONIBILIDAD: Int!){
                            dcbdisponibilidadHorariaByIDDOCENTEByDISPONIBILIDADByESTADODISPONIBILIDAD(IDDOCENTE: $IDDOCENTE, DISPONIBILIDAD: $DISPONIBILIDAD, ESTADODISPONIBILIDAD: $ESTADODISPONIBILIDAD){
                                ID
                                DIA
                                BLOQUE
                                DISPONIBILIDAD
                            }
                        }
                    `,fetchPolicy: 'no-cache',
                    variables: {
                        IDDOCENTE: this.pIdPersonal,
                        DISPONIBILIDAD: 1,
                        ESTADODISPONIBILIDAD: 1,
                    }
                })
                this.ddcbdisponibilidadHoraria = response.data.dcbdisponibilidadHorariaByIDDOCENTEByDISPONIBILIDADByESTADODISPONIBILIDAD;
                this.inicializarDisponibilidad();
            } catch (error) {
                console.log(error);
                Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
            } finally {
                this.dLoading = false;
            }
        },
        inicializarDisponibilidad() {
            const filas = this.bloques.length;
            const columnas = this.dias.length;            

            // Inicializa las matrices vacías
            this.disponibilidad = Array(filas).fill(null).map(() => Array(columnas).fill(false));

            // Llena las matrices con los datos de tu objeto
            this.ddcbdisponibilidadHoraria.forEach(item => {
                const rowIndex = item.BLOQUE - 1;
                const colIndex = this.diasMap[item.DIA];
                
                if (rowIndex >= 0 && rowIndex < filas && colIndex >= 0 && colIndex < columnas) {
                    this.$set(this.disponibilidad[rowIndex], colIndex, item.DISPONIBILIDAD === 1);
                }
            });
        },
        toggleDisponibilidad(bloqueIndex, diaIndex) {
            const newDisponibilidad = !this.disponibilidad[bloqueIndex][diaIndex];
            this.$set(this.disponibilidad[bloqueIndex], diaIndex, newDisponibilidad);
        },
        fuSave(){
            var disponibilidadActiva = "";
            
            this.disponibilidad.forEach((fila, rowIndex) => {
                fila.forEach((estaDisponible, colIndex) => {
                    if (estaDisponible) {
                        const dia = this.dias[colIndex];
                        // Obtener el ID del bloque usando el índice de fila (rowIndex). 
                        // Asumimos que `bloques` está ordenado y el ID de bloque es bloques[rowIndex].id
                        const bloqueId = this.bloques[rowIndex].id;
                        // Concatenar y agregar al arreglo
                        disponibilidadActiva += `${dia}_${bloqueId},`;
                    }
                });
            });
            disponibilidadActiva = disponibilidadActiva.replace(/\s+/g, '');
            if(disponibilidadActiva) disponibilidadActiva=disponibilidadActiva.slice(0, -1);
            
            if(disponibilidadActiva)
                this.fuCreate(disponibilidadActiva);
            else
                Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Debe seleccionar los bloques de horarios.'})
        },
        async fuCreate(vdisponibilidadActiva){
            this.dLoading = true;
            try {
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation dcbdisponibilidadhorariaCreate($IDDOCENTE: Int!, $Usuario: String!, $DisponibilidadActiva: String!){
                        dcbdisponibilidadhorariaCreate(IDDOCENTE: $IDDOCENTE, Usuario: $Usuario, DisponibilidadActiva: $DisponibilidadActiva){
                            error
                            message
                        }
                    }`,
                    variables: {
                        IDDOCENTE: this.pIdPersonal,
                        Usuario: this.ssUser.Usuario,
                        DisponibilidadActiva: vdisponibilidadActiva,
                    }
                });
                if(response.data.dcbdisponibilidadhorariaCreate.error==0){
                    Swal.fire({ icon: 'success', title: 'Correcto', html: 'Registro correcto'});
                } else
                    Swal.fire({ icon: 'error', title: '¡ ERROR !', html: 'Registro incorrecto'})
            } catch (error) {
                Swal.fire({ icon: 'error', title: '¡ ERROR !', text: 'Registro incorrecto'})
                console.log(error);
            } finally {
                this.dLoading = false;
            }
        }
    },
};
</script>
<style scoped>
    .green-cell {
    background-color: #1271A6 !important;
    }

    .red-cell {
    background-color: #F44336 !important;
    }

    .clickable-cell {
    cursor: pointer;
    border: 1px solid #ccc;
    }
</style>
